import { PropsWithChildren } from "react";
import { AuthProvider as OidcAuthProvider, AuthProviderProps } from "react-oidc-context";
import { User, UserManager, UserManagerSettings, WebStorageStateStore } from "oidc-client-ts";

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const isMobile = !!window.flutter_inappwebview;
  const redirectUri = `${window.location.origin}/auth`;

  const userManagerSettings: UserManagerSettings = {
    authority: process.env.REACT_APP_AUTH_AUTHORITY!,
    client_id: process.env.REACT_APP_AUTH_CLIENT_ID!,
    redirect_uri: redirectUri,
    automaticSilentRenew: false,
    silent_redirect_uri: redirectUri,
    scope: "offline_access openid password:change multi-factor:write sso:write",
    post_logout_redirect_uri: `${window.location.origin}/login`,
    userStore: new WebStorageStateStore({
      store: window.sessionStorage,
      prefix: "wisdom-auth.",
    }),
  };
  const userManager = new UserManager(userManagerSettings);
  const authProviderConfig: AuthProviderProps = {
    userManager,
    onSigninCallback: (_user: User | void): void => {
      window.history.replaceState({}, document.title, window.location.pathname);
    },
  };

  if (isMobile) {
    return <>{children}</>;
  }

  return <OidcAuthProvider {...authProviderConfig}>{children}</OidcAuthProvider>;
};
